import { soFetch } from 'so-fetch';
import { put } from '../../../utils/http';
import checkStatus from '../../../utils/checkStatus';
import * as constants from './product-constants';
import * as queries from './product-graphql-query';

export function editProductField({ updateField, updateBody, id, locationId }) {
  return dispatch => {
    let body = updateBody;
    if ((updateField === 'coverImageUrl' || updateField === 'profileImageUrl') && updateBody) {
      body += `?${Date.now()}`;
    }
    dispatch({
      type: constants.EDIT_USER_PRODUCT_PROFILE_FIELD_STARTING,
      payload: {
        id,
        updateField,
        locationId,
        updateBody: body,
      },
    });
    return put(`/proxy/profile/products/${id}?mutation=${queries.myProductMutation}`, {
      locationId,
      update: { [updateField]: body },
    })
    .then(checkStatus)
    .then(res => res.json())
    .then(res => dispatch({ type: constants.EDIT_USER_PRODUCT_PROFILE_FIELD, payload: res }));
  };
}

export function getUserProductProfile(productId) {
  return soFetch(`/proxy/profile/products/${productId}?query=${queries.myProductProfileQuery}`, {
    method: 'get',
    actionType: constants.GET_USER_PRODUCT_PROFILE,
    responseBinding: 'product',
  });
}

export function deleteCoverImageFromProduct(filename, id) {
  return dispatch => {
    return fetch('/proxy/profile/delete_cover_photos', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ filename: filename + id }),
    })
    .then(res => {
      if (res.status !== 200) throw new Error(res.status);
      return dispatch({
        type: constants.DELETE_COVER_IMAGE_FROM_PRODUCT,
        payload: { id },
      });
    })
    .catch(err => console.log('err in deleting product cover photo', err));
  };
}



// WEBPACK FOOTER //
// ./src/app/stores/profile/product/product-actions.js